import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

import { DevicesPayload } from '../../devices/components/devices.models';
import { HistoryResponse } from './history-api.types';
import { LOADER_CONTEXT } from '../../../../services/interceptors/loader.interceptor';

@Injectable({
  providedIn: 'root'
})
export class HistoryApiService {
  private http = inject(HttpClient);

  getAll(tableState?: DevicesPayload): Observable<HistoryResponse> {
    return this.http.post<HistoryResponse>(`/api/history`, tableState, {
      context: new HttpContext().set(LOADER_CONTEXT, true)
    });
  }
}
